import { IContacts, IWorkHours } from '../components/types'
import { contacts } from '../__generated__/contacts'
import { getPropByCode } from './gql'

export const createContacts = (data: contacts): IContacts => {
  const coords = getPropByCode(data.element.propertyValues, 'COORDS').split(',')
  const phone = getPropByCode(data.element.propertyValues, 'PHONE')
  const email = getPropByCode(data.element.propertyValues, 'EMAIL')
  const index = data.plus.filter(
    (plusItem) => plusItem.code === 'UF_CONTACTS_INDEX',
  )[0]?.value
  const address = data.plus.filter(
    (plusItem) => plusItem.code === 'UF_CONTACTS_ADDRESS',
  )[0]?.value

  const hours = data.plus.filter(
    (plusItem) => plusItem.code === 'UF_CONTACTS_WORK_HOURS',
  )[0]?.values

  const workHours: IWorkHours[] = hours?.map((hour) => {
    const hourArr = hour.split('|')

    return {
      day: hourArr[0].trim(),
      hours: hourArr[1].trim(),
    }
  })

  const wa = data.plus.filter(
    (plusItem) => plusItem.code === 'UF_MESSENGER_WA',
  )[0]?.value
  const tg = data.plus.filter(
    (plusItem) => plusItem.code === 'UF_MESSENGER_TG',
  )[0]?.value

  return {
    coords: coords.map((coord) => +coord),
    address,
    phone,
    email,
    index,
    workHours,
    wa,
    tg,
  }
}
